@if (loader.isLoading()) {
  <div
    class="fixed top-0 left-0 h-[3px] bg-primary z-[9999] transition-all duration-300 w-full animate-pulse"
  ></div>
}
